export const errorMessages = {
  'name':'This is not a valid name',
  'address':'This is not a valid address',
  'pin': 'This is not a valid pin'
};
